import { defineComponent, computed } from 'vue';
import { NodeType, RowType } from '@getaccept/editor-lib-new';
import { CreateContextualCommentButtonState } from '@getaccept/lib-shared-new/src/contextual-commenting/types/create-contextual-comment-button-state';
import { CommentsHelper } from '@getaccept/lib-shared-new/src/contextual-commenting/helpers/comments.helper';
import DetachedCommentAnchor from '@getaccept/lib-shared-new/src/contextual-commenting/components/DetachedCommentAnchor.vue';
import EditorCell from './EditorCell.vue';
export default defineComponent({
    name: 'EditorSideBySideRow',
    components: {
        DetachedCommentAnchor,
        EditorCell,
    },
    props: {
        cells: { type: Array, default: () => [] },
        isPdfViewer: { type: Boolean },
        mergeValues: {
            type: Object,
            default: () => ({ document: {}, sender: {}, recipients: [], entity: {} }),
        },
        blockWidthClass: {
            type: String,
            default: null,
        },
        pageWidth: { type: Number, default: 0 },
        isBlockToggled: { type: Boolean },
        theme: {
            type: Object,
            default: () => ({}),
        },
        comments: { type: Array, default: () => [] },
        selectedCommentId: { type: String, default: '' },
        showContextualComments: { type: Boolean, default: false },
        createContextualCommentButtonState: {
            type: String,
            default: CreateContextualCommentButtonState.Enabled,
        },
    },
    emits: [
        'create-comment',
        'select-comment',
        'node-click',
        'observe-node-visibility',
        'fetch-new-image',
    ],
    setup(props) {
        const isTextNodeFirst = computed(() => { var _a, _b, _c; return ((_c = (_b = (_a = props.cells[0]) === null || _a === void 0 ? void 0 : _a.nodes) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.type) === NodeType.Text; });
        const isParentFirstChild = (index) => index === 0;
        const isParentLastChild = (index) => index === props.cells.length - 1;
        const cellIds = computed(() => props.cells.map(({ id }) => id));
        const commentsWithoutCell = computed(() => props.comments.filter(comment => { var _a; return !cellIds.value.includes((_a = comment.editorSelection) === null || _a === void 0 ? void 0 : _a.cellId); }));
        return {
            commentsWithoutCell,
            RowType,
            isTextNodeFirst,
            isParentFirstChild,
            isParentLastChild,
            filterCommentsByCell: CommentsHelper.filterCommentsByCell,
        };
    },
});
